import store from '../store';
import * as ActionType from './contant';

export default {
  setProfile: value => {
    const action = { type: ActionType.SET_PROFILE, value };
    store.dispatch(action);
  },
  updateProfile: value => {
    const action = { type: ActionType.UPDATE_PROFILE, value };
    store.dispatch(action);
  },
  clearProfile: () => {
    const action = { type: ActionType.CLEAR_PROFILE };
    store.dispatch(action);
  }
};
